import { Component, HostListener, OnInit } from '@angular/core';
import { LotDetailContext } from './lot-detail.context';
import { InventoryContext } from '../../inventory-manager/inventory.context';
import { MAX_NAME_DISPLAY_SIZE } from '../../app.constants';
import { JhiLanguageService } from '../../shared/core-utils';
import { LotService } from '../../shared/inventory/service/lot.service';
import { Lot } from '../../shared/inventory/model/lot.model';

@Component({
    selector: 'jhi-basic-details-pane',
    templateUrl: './basic-details-pane.component.html'
})
export class BasicDetailsPaneComponent implements OnInit {

    lot: Lot;
    hasChanges: boolean;
    TOOLTIP_MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;

    @HostListener('window:message', ['$event'])
    onMessage(event) {
        if (event.data === 'lot-details-changed') {
            this.hasChanges = true;
            this.loadLot();
        }
    }

    constructor(public lotService: LotService,
                public lotDetailContext: LotDetailContext,
                public inventoryContext: InventoryContext,
                private jhiLanguageService: JhiLanguageService) {
    }

    ngOnInit(): void {
        this.loadLot();
    }

    loadLot(): void {
        this.lotService.getById(this.lotDetailContext.lotUUID).then((lot) => {
            this.lot = lot;
            if (lot) {
                this.lotDetailContext.lotId = lot.lotId;
            }
        });
    }

}
